import React, { ReactElement, ReactNode } from "react";

import { StyledInputSelectTrigger } from "./Styles";
import { ArrowDownIcon, ArrowDownSmallIcon } from "../Icons";
import { ElementWithRef, IOptionItemProps, Select } from "../Select";
import { StyledButton } from "../Trigger/Styles";

export interface InputSelectProps {
  onChange: (val: string | number | (string | number)[]) => void;
  size: string;
  selected: string;
  options: IOptionItemProps[];
  disabled?: boolean;
  search?: boolean;
  // @ToDo: Fix this
  disabledInternalSort?: boolean;
  keepSameOptionsOrder?: boolean;
  selectedLabel?: ReactNode;
  /** Set select target element */
  target?: ElementWithRef<Element>;
  /** Render option */
  renderOption?: (
    option: Record<string, ReactNode>,
    data: Record<string, unknown>
  ) => string | ReactElement;
  /** Custom filter function for additional filtering criteria */
  filterCriteria?: (option: IOptionItemProps, filter: string) => boolean;
}

export const InputSelect: React.FC<InputSelectProps> = ({
  onChange,
  size,
  selected,
  options,
  search = false,
  disabled = false,
  disabledInternalSort = true,
  keepSameOptionsOrder = true,
  selectedLabel,
  renderOption,
  filterCriteria,
}) => {
  return (
    <Select
      onChange={onChange}
      forceCloseMenu
      disableSearch={!search}
      target={
        <StyledButton css="flex-shrink:0">
          <StyledInputSelectTrigger $disabled={disabled} $size={size}>
            {selectedLabel ? selectedLabel : selected}
            {size === "big" ? (
              <ArrowDownIcon fill="var(--color-theme-700)" />
            ) : (
              <ArrowDownSmallIcon fill="var(--color-theme-700)" />
            )}
          </StyledInputSelectTrigger>
        </StyledButton>
      }
      options={options}
      disabledInternalSort={disabledInternalSort}
      keepSameOptionsOrder={keepSameOptionsOrder}
      selected={selected}
      renderOption={renderOption}
      filterCriteria={filterCriteria}
    />
  );
};
